import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['typeSelect', 'tabContainer'];

  // Disable all containers on connect so that unselected tab type fields
  // are not submitted with the form (hidden inputs are submitted even when invisible).
  connect() {
    this.tabContainerTargets.forEach((container) => {
      this.#setInputsDisabled(container, true);
    });
  }

  selectType() {
    const tabType = this.typeSelectTarget.value;

    this.tabContainerTargets.forEach((container) => {
      const isSelected = container.dataset.tabType === tabType;
      container.hidden = !isSelected;
      this.#setInputsDisabled(container, !isSelected);
    });
  }

  #setInputsDisabled(container, disabled) {
    container.querySelectorAll('input, select, textarea').forEach((input) => {
      input.disabled = disabled;
    });
  }
}
